import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SdsDialogRef } from '@gsa-sam/components';
import { SignInWorkflowService } from '@gsa-sam/layout';
import { environment } from './../../environments/environment';
@Component({
  selector: 'sam-auth-interceptor',
  templateUrl: './auth-interceptor.component.html',
  styleUrls: ['./auth-interceptor.component.scss'],
  standalone: false,
})
export class AuthInterceptorPage implements OnInit {
  constructor(
    private signInWorkflowService: SignInWorkflowService,
    private location: Location,
  ) {}

  ngOnInit() {
    let env = {
      apiUrl: environment.API_UMBRELLA_URL,
      apiKey: environment.API_UMBRELLA_KEY,
      production: !environment.LOCAL,
    };
    this.signInWorkflowService.setEnviroment(env);
    const modalRefObs = this.signInWorkflowService.signIn();
    modalRefObs.subscribe((modalRef: SdsDialogRef<any, any>) => {
      modalRef.afterClosed().subscribe(() => this.location.back());
    });
  }
}
